var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"personalServices"},[_c('Nav'),_vm._v(" "),_c('LoginForm',{attrs:{"title":"个人服务","pics":[
        '/static/p1.png',
        '/static/p2.png',
        '/static/p3.png',
        '/static/p4.png'
      ],"isPersonal":true,"description":"中华人民共和国公民凭身份证及个人身份实名认证登录服务平台，可进行本人基本信息完善填写、本人信息数据查询、授权数据档案查验、数据勘误申请等操作。"}})],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e4abaf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalServices/index.vue
// module id = null
// module chunks = 